<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style=";margin-right:0.5em;border-radius:8px;margin-top:-15px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Faculty Canteen Payment</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <br>
       <v-row justify="center" dense>
               <v-col cols="12" sm="3" md="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
               </v-col>
                <v-col cols="12" sm="3" md="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="month" :items="month_list" item-text="name" item-value="id" label="Month" outlined persistent-hint hint="Please Select Month" />
               </v-col>
                <v-col col="12" sm="2" md="2" v-if="this.ay && this.month">
                        <v-btn rounded color="warning" @click="fetchData()">Fetch</v-btn>
                    </v-col>
            </v-row>
       </v-card>
       <v-card class="box" v-if="show_faculty_canteen_details_card">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Faculty Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><b>Name</b></p>
                        <strong>{{faculty_canteen_details[0].employee_name}}</strong>
                    </v-col>
                    <v-col cols="12" sm="1">
                        <p><b>Month</b></p>
                        <strong>{{faculty_canteen_details[0].month}}</strong>
                    </v-col>
                    <v-col cols="12" sm="1">
                        <p><b>Amount To Pay</b></p>
                        <strong>{{faculty_canteen_details[0].amount_to_pay}}</strong>
                    </v-col>
                    <v-col cols="12" sm="1">
                        <p><b>Paid Till Now</b></p>
                        <strong>{{faculty_canteen_details[0].paid_till_now}}</strong>
                    </v-col>
                    <v-col cols="12" sm="1">
                        <p><b>Balance</b></p>
                        <strong>{{faculty_canteen_details[0].balance}}</strong>
                    </v-col>
                   
                </v-row>
            </v-card>

<!-- {{payment_data}} -->
        <v-card class="box" v-if="payment_data != null">
             <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Pay Canteen Fees</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Amount To Pay" v-model="faculty_canteen_fees" type="number" dense rounded readonly outlined hint="Please Enter Amount It's Rsequired"></v-text-field>
                    </v-col>
                    <form :action="url" @submit="payment" name="paytmform" method="POST">
                        <input type="hidden" :value="this.payment_data[0].orgid" name="orgid" />
                        <input type="hidden" :value="this.payment_data[0].tenantid" name="tenantid" />
                        <input type="hidden" :value="this.payment_data[0].uid" name="uid" />
                        <input type="hidden" :value="this.payment_data[0].instructor_id" name="instructor_id" />
                        <input type="hidden" :value="this.month" name="json_pre_trans_data" />
                        <input type="hidden" :value="this.faculty_canteen_fees" name="fee_amount" />
                        <input type="hidden" :value="this.ay" name="ay_id" />
                        <input type="hidden" :value="this.month" name="month_id" />
                        <v-btn class="button" type="submit" :loading="loader" color="warning" :disabled="faculty_canteen_fees == 0 " v-if="faculty_canteen_fees">Pay</v-btn>
                    </form>
                </v-row>
        </v-card>
        
     <v-card class="box" v-if="faculty_canteen_fees_list!=''">
     <v-data-table  :headers="headers" :items="faculty_canteen_fees_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Faculty Canteen Fees List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card>
        </v-container>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Faculty Canteen Payment Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/hWRli7ZMqiI?si=XbV6V6h_KnFQ6Opp"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      videoDialog:false,
      color: "",
      snackbar: false,
      overlay: false,
      headers:[
      { text: "Month", value: "month" },
      { text: "Amount To Pay", value: "amount_to_pay" },
      { text: "Amount Paid", value: "paid_till_now" },
      { text: "Balance", value: "balance" },
      { text: "Academicyear", value: "academicyear" },
      ],
      month_list:[],month:"",ay_list:[],ay:"",faculty_canteen_details:[],
      show_faculty_canteen_details_card:false,faculty_canteen_fees:null,payment_data:null,
       pg_loader: false,faculty_canteen_fees_list:[]
  }),
   methods: {
     payment() {
                this.loader=true
                var formData = new FormData(paytmform);
                this.pg_loader = false;
            },
      fetchData() {
                this.payment_data = null;
                const data = {
                    ay: this.ay,
                    month: this.month,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/getFacultyCanteenDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.faculty_canteen_details = res.data.faculty_canteen_details;
                            this.show_faculty_canteen_details_card=res.data.has_applied_for_month
                        }else if (res.data.flag == "No") {
                            this.show_faculty_canteen_details_card=res.data.has_applied_for_month
                            this.faculty_canteen_fees=res.data.faculty_canteen_fees
                            this.payment_data=res.data.payment_data
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        } 
                        else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                      //  this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
     onLoad() {
                axios
                    .post("Canteen/facultyCanteenHome")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.current_ay);
                            this.month_list = res.data.month_list;
                            this.faculty_canteen_fees_list=res.data.faculty_canteen_fees_list
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  created() {
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytmFacultyCanteen";
        },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }

    i {
        font-size: 20px !important;
    }

    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }
    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }

    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }

    i {
        font-size: 26px;
        cursor: pointer;
    }

    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }

    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

    @media only screen and (max-width: 600px) {
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }
    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }
    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
    .note-list {
        background-color: orange;
    }
</style>